import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "legal-page" }
const _hoisted_2 = { class: "text-capitalize-first" }
const _hoisted_3 = { class: "legal-content" }

import {useRouter} from "vue-router";
import SvgIcon from "@/components/SvgIcon.vue";
import {$t} from "@/i18n";


export default /*@__PURE__*/_defineComponent({
  __name: 'LegalPageLayout',
  props: {
    title: {}
  },
  setup(__props: any) {



const router = useRouter();

const back = () => {
  if (window.history.state?.back) {
    router.back()
  } else {
    router.push('/')
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("a", {
      href: "#",
      onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (back()), ["prevent"])),
      class: "nav-back"
    }, [
      _createVNode(SvgIcon, { icon: "back" }),
      _cache[1] || (_cache[1] = _createTextVNode()),
      _createElementVNode("span", _hoisted_2, _toDisplayString(_unref($t)('back')), 1)
    ]),
    _createElementVNode("h1", null, _toDisplayString(_ctx.title), 1),
    _createElementVNode("div", _hoisted_3, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ]))
}
}

})